import React, {Component} from 'react';

import {Form, ErrorContainer, InputWrapper} from 'form';

import {Link} from 'components/ReactRouterDomLocalized';

import {changePassword} from 'backend-helpers/passwordRecover';

import {t} from 'l10n';

export default class ModalMenuPasswordChangeForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            done: false
        };

        this.onSubmit = this.onSubmit.bind(this);
    }

    onSubmit(formData, setErrors) {

        changePassword(formData)
            .then(() => { this.setState({done: true}) })
            .catch((error) => { setErrors(error.messages || error.message, true); });
    }

    render() {
        let {prt} = this.props;

        return (
            <div>
                <p className="name">
                    <span>{t('Password recover')}</span>
                    <Link to="/?login" className="header-button">{t('Log in')}</Link>
                </p>
                {!this.state.done ?
                    <Form onSubmit={this.onSubmit}>
                        <ErrorContainer data-errorcontainer={true} />

                        <input type="hidden" name="prt" value={prt}/>

                        <div className="space-between">
                            <InputWrapper data-formfield={true} name="new_password" placeholder={t('New password')} type="password"/>
                        </div>

                        <div className="space-between">
                            <InputWrapper data-formfield={true} name="new_password_repeat" placeholder={t('Confirm new password')} type="password"/>
                        </div>

                        <div className="space-between">
                            <button type='submit' className="btn-submit">{t('Send')}</button>
                        </div>
                    </Form>

                    :

                    <p className="help-text">{t('Your profile data have been saved.')}</p>
                }
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/modals/ModalMenu/ModalMenuPasswordChangeForm.js